import callAPI from 'api'

export type Country = {
  id: number
  name: string
  iso3: string
  numeric_code: string
  iso2: string
  phonecode: string
  currency: string
  currency_name: string
  currency_symbol: string
  native: string
  region: string
  region_id: number
  subregion: string
  subregion_id: number
  latitude: number
  longitude: number
  emoji: string
  emojiU: string
}

export type State = {
  id: number
  name: string
  country_id: number
  country_code: string
  fips_code: string
  iso2: string
  latitude: number
  longitude: number
  cities: City[]
}

type City = {
  id: number
  name: string
}

export const getCountries = async () =>
  await callAPI<Country[]>('crm_get_countries', [], {
    requireAuthorization: true,
  })

export const getStatesByCountryId = async (countryId: number) =>
  await callAPI<State[]>('crm_get_states_by_country_id', [{ country_id: countryId }], {
    requireAuthorization: true,
  })
